export { default } from "./QuizAnswersSetting";
